import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-description',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="surface-card p-6 md:p-8 border border-border shadow-sm antialiased select-text"
    >
      <div class="flex items-center gap-3 mb-5 pb-3 border-b border-dashed border-border-subtle">
        <div
          class="w-8 h-8 rounded-xl bg-primary/10 flex items-center justify-center text-primary shadow-sm border border-primary/20"
        >
          <i class="fa-solid fa-file-text text-xs"></i>
        </div>
        <div>
          <h4 class="text-[10px] font-black uppercase tracking-widest text-text-muted font-mono">
            تفاصيل العقار
          </h4>
          <h2 class="text-lg font-black text-text-primary tracking-tight mt-0.5">الوصف</h2>
        </div>
      </div>

      @if (description && description.trim()) {
        <p
          class="text-sm font-medium text-text-secondary leading-relaxed tracking-wide whitespace-pre-line selection:bg-primary/20"
        >
          {{ description }}
        </p>
      } @else {
        <div
          class="py-8 flex flex-col items-center justify-center border border-dashed border-border bg-bg-secondary/40 rounded-2xl text-center font-mono px-4"
        >
          <div
            class="w-12 h-12 rounded-2xl bg-surface-elevated flex items-center justify-center text-text-muted mb-4 border border-border-subtle shadow-sm"
          >
            <i class="fa-solid fa-notebook text-lg"></i>
          </div>
          <h4 class="text-xs font-black text-text-secondary uppercase tracking-wider mb-2">
            لا يوجد وصف
          </h4>
          <p
            class="text-[11px] font-medium text-text-muted max-w-[280px] leading-relaxed normal-case font-sans"
          >
            لم يتم تقديم ملخص أو تفاصيل وصف هذا العقار بعد.
          </p>
        </div>
      }
    </div>
  `,
})
export class DescriptionComponent {
  @Input() description: string = '';
}
